import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-badge-active.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-status-badge-idle.svg";
import { ReactComponent as RestoringImg } from "../../../img/ico-status-badge-commit.svg";
import { ReactComponent as LockedImg } from "../../../img/ico-status-badge-lock.svg";
import { ReactComponent as MigrationImg } from "../../../img/ico-status-badge-migration.svg";
import { ReactComponent as PoweringUpImg } from "../../../img/ico-status-badge-on.svg";
import { ReactComponent as PoweringDownImg } from "../../../img/ico-status-badge-off.svg";
import { ReactComponent as PausedImg } from "../../../img/ico-status-badge-pause.svg";
import { ReactComponent as SuspendImg } from "../../../img/ico-status-badge-stop.svg";
import { ReactComponent as RebootImg } from "../../../img/ico-status-badge-restart.svg";
import { ReactComponent as WaitForLaunchImg } from "../../../img/ico-status-badge-ready.svg";
import { ReactComponent as SavingImg } from "../../../img/ico-status-badge-sleep.svg";
import { ReactComponent as NotRespondingImg } from "../../../img/ico-status-badge-no-response.svg";
import { ReactComponent as UnknwonImg } from "../../../img/ico-status-badge-unknown.svg";

// import VmMigrationStart from "./vmMigrationStart";
import VmImageAdd from "./VmImageAdd";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import VmImageUpdate from "./VmImageUpdate";
import { DropdownType } from "../../base/CustomDropdown";



export interface VmImageMgmtData {
    vm_image_id: string,
    vm_image_name: string,
    vm_image_description: string,
    vm_image_type_code: string,
    vm_image_status_code: string,
    vm_image_format_type_code: string,
    vm_snapshot: string,
    share_type_code: string,
    os_type_code: string,
    real_size_mb: number,
    virt_size_mb: number,
    protect_yn: boolean,
    create_ts: string,
    update_ts: string,
    project: {
        project_id: string;
        project_name: string;
    }
}



export const VmImageMgmtData  = {
    vm_image_id: '',
    vm_image_name: '',
    vm_image_description: '',
    vm_image_type_code: '',
    vm_image_status_code: '',
    vm_image_format_type_code: '',
    vm_snapshot: '',
    share_type_code: '',
    os_type_code: '',
    real_size_mb: 0,
    virt_size_mb: 0,
    protect_yn: false,
    create_ts: '',
    update_ts: '',
    project: {
        project_id: '',
        project_name: ''
    }
}




export const categoryFilters:ListFilter[] = [
    {
        id: 1,
        name: i18n.t("TOTAL_TEXT"),
        type: "",
        code: "",
        count: 0
    },
    {
        id: 2,
        name: i18n.t("ACTIVE_TEXT"),
        type: "vmImageStatusCode",
        code: "ACT",
        count: 0
    },
    {
        id: 3,
        name: i18n.t("INACTIVE_TEXT"),
        type: "vmImageStatusCode",
        code: "DACT",
        count: 0
    },
    {
        id: 4,
        name: i18n.t("QUEUED_TEXT"),
        type: "vmImageStatusCode",
        code: "QUEU",
        count: 0
    },
    {
        id: 5,
        name: i18n.t("SAVING_TEXT"),
        type: "vmImageStatusCode",
        code: "SAVE",
        count: 0
    },
    {
        id: 6,
        name: i18n.t("UPLOADING_TEXT"),
        type: "vmImageStatusCode",
        code: "UPLD",
        count: 0
    },
    {
        id: 7,
        name: i18n.t("KILLED_TEXT"),
        type: "vmImageStatusCode",
        code: "KILL",
        count: 0
    },
    {
        id: 8,
        name: i18n.t("DELETED_TEXT"),
        type: "vmImageStatusCode",
        code: "DEL",
        count: 0
    },
    {
        id: 9,
        name: i18n.t("PENDING_DELETE_TEXT"),
        type: "vmImageStatusCode",
        code: "PDEL",
        count: 0
    },
    {
        id: 10,
        name: i18n.t("IMPORTING_TEXT"),
        type: "vmImageStatusCode",
        code: "IMPT",
        count: 0
    }
];

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("VM_IMAGE_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "VM_IMAGE_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "VM_IMAGE_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "VM_IMAGE_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("IMAGE_NAME_TEXT"),
        accessor: "vm_image_name",
        disableSortBy: false,
        style: {
            width: "240px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? value : '-'}</div>)
    },
    {
        Header: i18n.t("TYPE_TEXT"),
        accessor: "vm_image_type_code",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.resourceContainer}}>
                {
                value === "IMG" ? "Image"
                : value === "SNAP" ? "Snapshot"
                : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("STATUS_TEXT"),
        accessor: "vm_image_status_code",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value === "ACT" ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value === "ACT" ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                {
                    value === "ACT" ? "Active"
                    : value === 'QUEU' ? "Queued"
                    : value === 'SAVE' ? "Saving"
                    : value === 'UPLD' ? "Uploading"
                    : value === "IMPT" ? "Importing"
                    : value === 'DACT' ? "Deactive"
                    : value === 'KILL' ? "Killed"
                    : value === 'DEL' ? "Deleted"
                    : value === 'PDDEL'  ? "PendingDeleted"
                    : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("FILE_SIZE_TEXT"),
        accessor: "real_size_mb",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{(!value) ? 0 : (value > 10000) ? (value / 1024).toFixed(1).toString() + 'GB' : value + 'MB'}</div>)
    },
    {
        Header: i18n.t("VIRT_VOLUME_SIZE_TEXT"),
        accessor: "virt_size_mb",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{(!value) ? 0 : (value > 10000) ? (value / 1024).toFixed(1).toString() + 'GB' : value + 'MB'}</div>)
    },
    {
        Header: i18n.t("DISK_FORMAT_TEXT"),
        accessor: "vm_image_format_type_code",
        disableSortBy: false,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.countContainer }}>
                {
                value === 'ISO' ? "ISO"
                : value === 'QCOW' ? "QCOW2"
                : value === 'RAW' ? "RAW"
                : value === 'VDI' ? "VDI"
                : value === 'VHD' ? "VHD"
                : value === 'VMDK' ? "VMDK"
                : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("GUEST_OS_TEXT"),
        accessor: "os_type_code",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.purpleText}}>
                {value == "NONE" ? "-" : value}
            </div>
        )
    },
    {
        Header: i18n.t("SHARE_TYPE_TEXT"),
        accessor: "share_type_code",
        disableSortBy: false,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 50, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "PUB" ? "#66abe8" : value === "PRJ" ? "#92ca6e" : "#b6bfce",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#fff"
            }}>
                {
                    value === "PUB" ? "Public"
                    : value === "PRJ" ? "Personal"
                    : value === "HDN" ? "Hidden"
                    : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("PROJECT_NAME_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.project_name ? value.project_name : '-'}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];

export const vmImageAddModalContent = {
    title: i18n.t("VM_IMAGE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <VmImageAdd />,
}

export const vmImageUpdateModalContent = {
    title: i18n.t("VM_IMAGE_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <VmImageUpdate />,
}

export const imageFormatDropdownItem:DropdownType[] = [
    {
        value: "ISO",
        label: "ISO"
    },
    {
        value: "QCOW",
        label: "QCOW2"
    },
    {
        value: "RAW",
        label: "RAW"
    },
    {
        value: "VDI",
        label: "VDI"
    },
    {
        value: "VHD",
        label: "VHD"
    },
    {
        value: "VMDK",
        label: "VMDK"
    },
]

export const guestOsDropdownItem:DropdownType[] = [
    {
        value: "NONE",
        label: "NONE"
    },
    {
        value: "ARCH",
        label: "ARCH"
    },
    {
        value: "CENTOS",
        label: "CENTOS"
    },
    {
        value: "DEBIAN",
        label: "DEBIAN"
    },
    {
        value: "FEDORA",
        label: "FEDORA"
    },
    {
        value: "FREEBSD",
        label: "FREEBSD"
    },
    {
        value: "GENTOO",
        label: "GENTOO"
    },
    {
        value: "MANDRAKE",
        label: "MANDRAKE"
    },
    {
        value: "MANDRIVA",
        label: "MANDRIVA"
    },
    {
        value: "MES",
        label: "MES"
    },
    {
        value: "MSDOS",
        label: "MSDOS"
    },
    {
        value: "NETBSD",
        label: "NETBSD"
    },
    {
        value: "NETWARE",
        label: "NETWARE"
    },
    {
        value: "OPENBSD",
        label: "OPENBSD"
    },
    {
        value: "OPENSOLARIS",
        label: "OPENSOLARIS"
    },
    {
        value: "OPENSUSE",
        label: "OPENSUSE"
    },
    {
        value: "RHEL",
        label: "RHEL"
    },
    {
        value: "SLED",
        label: "SLED"
    },
    {
        value: "UBUNTU",
        label: "UBUNTU"
    },
    {
        value: "WINDOWS",
        label: "WINDOWS"
    },
]



const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    }
}